module.exports = __webpack_public_path__ + "static/img/gf3.d2e1ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gf3.png
// module id = xYlS
// module chunks = 1